<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form">
      <div class="empadronamiento__intro__main__form__container">
        <h2>{{errorMessage}}</h2>
      </div>
    </div>
  </div>
</template>

<script>
import persistentData from '@/plugins/persistentData';

export default {
  data() {
    return {
      errorMessage : persistentData.getData('errorServer', false)
    }
  }
};
</script>
